import { styled } from '@mui/material';
import Typography, { type TypographyProps } from '@mui/material/Typography';

interface PulsatingTextProps extends TypographyProps {}

export const StyledPulsatingText = styled(Typography)<TypographyProps>(() => ({
  animation: 'pulse 1s ease-in-out infinite',
  display: 'inline-block',
  textAlign: 'center',

  '@keyframes pulse': {
    '0%, 100%': { opacity: 0.35 },
    '50%': { opacity: 1 },
  },

  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
}));

export const PulsatingText = ({ children, ...rest }: PulsatingTextProps) => (
  <StyledPulsatingText {...rest}>{children}</StyledPulsatingText>
);
